/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "Ȟtálehaŋ",
        "0": "Lé aŋpétu kiŋ",
        "1": "Híŋhaŋni kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ {0}-čháŋ kiŋháŋ"
        },
        "past": {
          "other": "Hékta {0}-čháŋ k’uŋ héhaŋ"
        }
      },
      "day-narrow": {
        "-1": "Ȟtálehaŋ",
        "0": "Lé aŋpétu kiŋ",
        "1": "Híŋhaŋni kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ {0}-čháŋ kiŋháŋ"
        },
        "past": {
          "other": "Hékta {0}-čháŋ k’uŋ héhaŋ"
        }
      },
      "day-short": {
        "-1": "Ȟtálehaŋ",
        "0": "Lé aŋpétu kiŋ",
        "1": "Híŋhaŋni kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ {0}-čháŋ kiŋháŋ"
        },
        "past": {
          "other": "Hékta {0}-čháŋ k’uŋ héhaŋ"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "Letáŋhaŋ owápȟe {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta owápȟe {0} kʼuŋ héhaŋ"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "Letáŋhaŋ owápȟe {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta owápȟe {0} kʼuŋ héhaŋ"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "Letáŋhaŋ owápȟe {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta owápȟe {0} kʼuŋ héhaŋ"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "Letáŋhaŋ oȟ’áŋkȟo {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta oȟ’áŋkȟo {0} k’uŋ héhaŋ"
        }
      },
      "month": {
        "-1": "Wí kʼuŋ héhaŋ",
        "0": "Lé wí kiŋ",
        "1": "Tȟokáta wí kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ wíyawapi {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta wíyawapi {0} kʼuŋ héhaŋ"
        }
      },
      "month-narrow": {
        "-1": "Wí kʼuŋ héhaŋ",
        "0": "Lé wí kiŋ",
        "1": "Tȟokáta wí kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ wíyawapi {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta wíyawapi {0} kʼuŋ héhaŋ"
        }
      },
      "month-short": {
        "-1": "Wí kʼuŋ héhaŋ",
        "0": "Lé wí kiŋ",
        "1": "Tȟokáta wí kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ wíyawapi {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta wíyawapi {0} kʼuŋ héhaŋ"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "Letáŋhaŋ okpí {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta okpí {0} k’uŋ héhaŋ"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "Letáŋhaŋ okpí {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta okpí {0} k’uŋ héhaŋ"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "Letáŋhaŋ okpí {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta okpí {0} k’uŋ héhaŋ"
        }
      },
      "week": {
        "-1": "Okó kʼuŋ héhaŋ",
        "0": "Lé okó kiŋ",
        "1": "Tȟokáta okó kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ okó {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta okó {0} kʼuŋ héhaŋ"
        }
      },
      "week-narrow": {
        "-1": "Okó kʼuŋ héhaŋ",
        "0": "Lé okó kiŋ",
        "1": "Tȟokáta okó kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ okó {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta okó {0} kʼuŋ héhaŋ"
        }
      },
      "week-short": {
        "-1": "Okó kʼuŋ héhaŋ",
        "0": "Lé okó kiŋ",
        "1": "Tȟokáta okó kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ okó {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta okó {0} kʼuŋ héhaŋ"
        }
      },
      "year": {
        "-1": "Ómakȟa kʼuŋ héhaŋ",
        "0": "Lé ómakȟa kiŋ",
        "1": "Tȟokáta ómakȟa kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ ómakȟa {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta ómakȟa {0} kʼuŋ héhaŋ"
        }
      },
      "year-narrow": {
        "-1": "Ómakȟa kʼuŋ héhaŋ",
        "0": "Lé ómakȟa kiŋ",
        "1": "Tȟokáta ómakȟa kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ ómakȟa {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta ómakȟa {0} kʼuŋ héhaŋ"
        }
      },
      "year-short": {
        "-1": "Ómakȟa kʼuŋ héhaŋ",
        "0": "Lé ómakȟa kiŋ",
        "1": "Tȟokáta ómakȟa kiŋháŋ",
        "future": {
          "other": "Letáŋhaŋ ómakȟa {0} kiŋháŋ"
        },
        "past": {
          "other": "Hékta ómakȟa {0} kʼuŋ héhaŋ"
        }
      }
    },
    "locale": "lkt"
  });
}